<template>
  <div class="py-2">
    <label
      class="block uppercase tracking-wide text-gray-700 text-lg font-thin mb-2"
      :for="label"
      >{{ label }}</label
    >
    <img v-if="uploadUrl" :src="uploadUrl" class="uploaded-image" />
    <span v-if="!uploadUrl && progress">{{ progress }}%</span>
    <input
      :id="label"
      type="file"
      class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
      @input="this.onChange"
      @change="this.onChange"
      v-bind="$attrs"
      :required="!fileUrl && !uploadUrl"
    />
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";

export default {
  name: "BaseFileUploader",
  props: {
    id: String,
    label: String,
    path: String,
    fileUrl: String,
    uuid: Boolean,
  },
  created() {
    this.user = this.$auth.currentUser;

    if (this.fileUrl) {
      this.uploadUrl = this.fileUrl;
    }
  },
  data() {
    return {
      user: this.user,
      uploadUrl: null,
      progress: null,
    };
  },
  methods: {
    onChange($event) {
      if ($event.target.files) {
        this.handleUpload($event.target.files);
      }
    },
    reset() {
      this.$refs["path"].reset();
    },
    handleUpload(files) {
      if (files[0].size < 50000000) {
        this.progress = null;
        this.uploadUrl = null;
        const uploadTask = this.$storage
          .ref()
          .child(
            `${this.user.uid}/${this.path}/${
              this.uuid
                ? uuidv4() + "." + files[0].name.split(".").pop()
                : files[0].name
            }`
          )
          .put(files[0]);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            this.progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            this.$emit("updateProgress", this.progress);
          },
          (error) => {
            console.error(error);
          },
          () => {
            uploadTask.snapshot.ref.getDownloadURL().then((fileUrl) => {
              this.uploadUrl = fileUrl;
              this.$emit("uploaded", { id: this.id, fileUrl });
            });
          }
        );
      } else if (files[0].size > 50000000) {
        //this.progress = null,
        alert("File must be less than 6mb");
        this.reset(), (this.fileUrl = null), (this.uploadUrl = null);
      }
    },
  },
};
</script>
<style scoped>
.uploaded-image {
  width: 25%;
}
</style>
